import { z } from "zod";

/**
 * Checkout response (from POST /suscripcion/checkout)
 */
export const checkoutResponseSchema = z.object({
	estado: z.string(),
	mensaje: z.string(),
	checkout_url: z.string().nullable().optional(),
	token: z.string().nullable().optional(),
	plan: z.string().nullable().optional(),
	plan_id_solicitado: z.number().nullable().optional(),
	ciclo_facturacion: z.string().nullable().optional(),
	tarjeta_ultimos_4: z.string().nullable().optional(),
});
export type CheckoutResponse = z.infer<typeof checkoutResponseSchema>;
